import * as Msal from 'msal'
import config from '../config/auth.config'

export default class AuthService {
  static IsLoggingOutDueToResetPassword = false;

  constructor() {
    var msalConfiguration = {
      auth: {
        clientId: config.clientid,
        authority: config.authority,
        navigateToLoginRequestUrl: false,
        validateAuthority: false
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true
      }
    }
    this.app = new Msal.UserAgentApplication(msalConfiguration)
    this.app.handleRedirectCallback(this.authCallback.bind(this));
    this.token = null;
    this.accesstoken = null;
    this.isSubscriptionActive = false;
  }

  authCallback(error, response) {
    if (response && response.idToken && response.idToken.claims) {
      if (response.idToken.claims['isForgotPassword'] === true) {
        AuthService.IsLoggingOutDueToResetPassword = true;
        alert('Your password has been updated. You can now sign in.');
        this.app.logout();
      }
    }
  }

  loginPopup() {
    var loginRequest = {
      scopes: config.scopes
    }

    this.app.loginPopup(loginRequest).then(
      token => {
        this.token = token;
      },
      error => {
      }
    );
  }

  getUser() {
    if (!this.token) {
      this.acquireToken(function () {
        return {
          "display_name": this.token.account.idTokenClaims.given_name + " " + this.token.account.idTokenClaims.family_name,
          "email": this.token.account.idTokenClaims.emails[0]
        }
      }.bind(this));
    }
    else
      return {
        "display_name": this.token.account.idTokenClaims.given_name + " " + this.token.account.idTokenClaims.family_name,
        "email": this.token.account.idTokenClaims.emails[0]
      }
  }

  getToken() {
    this.acquireToken();
    return this.token;
  }

  getAccessToken(successFunction, failureFunction) {
    this.acquireToken(successFunction, failureFunction);
  }

  acquireToken(resolve, reject) {
    var loginRequest = {
      scopes: config.scopes
    }
    this.app.acquireTokenSilent(loginRequest).then(function (accessTokenResponse) {
      this.token = accessTokenResponse;
      resolve();
    }.bind(this)).catch(function (error) {
      //Acquire token silent failure, send an interactive request.
      if (error.errorMessage && error.errorMessage.indexOf("interaction_required") !== -1) {
        this.app.acquireTokenPopup(loginRequest).then(function (accessTokenResponse) {
          this.token = accessTokenResponse;
          resolve();
        }.bind(this)).catch(function (error) {
          reject();
        });
      }
      if (reject)
        reject();
    });
  }

  async acquireTokenAsync() {
    let loginRequest = {
      scopes: config.scopes
    }

    try {
      let authResponse = await this.app.acquireTokenSilent(loginRequest)

      return this._getUserData(authResponse)
    } catch (error) {
      // TODO: test this case
      if (this._isInteractionRequired(error)) {
        try {
          let authResponse = await this.app.acquireTokenPopup(loginRequest)

          return this._getUserData(authResponse)
        } catch (error) {
          throw error
        }
      }

      throw error
    }
  }

  async loginAsync() {
    try {
      return await this.acquireTokenAsync()
    } catch (error) {
      this.app.loginRedirect({ scopes: config.scopes });

      throw error
    }
  }

  logout() {
    this.app.logout()
  }

  _getUserData(authResponse) {
    return {
      userData: {
        name: authResponse.idTokenClaims.name,
        email: authResponse.idTokenClaims.emails[0],
        token: authResponse.accessToken,
      },
      newUser: authResponse.idTokenClaims.newUser
    }
  }

  _isInteractionRequired(error) {
    return error.errorCode === "consent_required"
      || error.errorCode === "interaction_required"
      || error.errorCode === "login_required"
      || error.errorCode === "user_login_error";
  }
}
